// Sync the content between files below this line:
export const MESSAGE_PREFIX = 'pulse-tracker-proxy';
export const MESSAGE_TYPE_REQUEST = `${MESSAGE_PREFIX}:request`;
export const MESSAGE_TYPE_ACK = `${MESSAGE_PREFIX}:ack`;
export const MESSAGE_TYPE_INVOKE = `${MESSAGE_PREFIX}:invoke`;
export const MESSAGE_TYPE_RETURN = `${MESSAGE_PREFIX}:return`;
export const MESSAGE_TYPE_RETURN_ERROR = `${MESSAGE_PREFIX}:return-error`;
export const ALLOWED_METHODS = ['track'];
export function isPulseProxyMessage(message) {
    return (message !== null &&
        typeof message === 'object' &&
        'type' in message &&
        typeof message.type === 'string' &&
        message.type.startsWith(MESSAGE_PREFIX));
}
